// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth, GoogleAuthProvider} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB3U-qsA-2hEfK4ZkklGTLbW9JIgr4WgQQ",
  authDomain: "kr-blogs.firebaseapp.com",
  projectId: "kr-blogs",
  storageBucket: "kr-blogs.appspot.com",
  messagingSenderId: "742633352847",
  appId: "1:742633352847:web:7d307845c021adafa00afa"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);